import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M1242.35294,65 L1242.35294,334.138824 L1609.97647,548.275294 C1661.92941,578.543529 1694.11765,634.562353 1694.11765,694.647059 L1694.11765,694.647059 L1694.11765,1081.47059 L1920,1081.47059 L1920,1646.17647 L1362.97412,1646.17647 L1045.27059,1831.28706 C1018.95529,1846.64706 989.477647,1854.32706 960,1854.32706 C930.522353,1854.32706 901.044706,1846.64706 874.729412,1831.28706 L874.729412,1831.28706 L557.025882,1646.17647 L-2.27373675e-13,1646.17647 L-2.27373675e-13,1081.47059 L225.882353,1081.47059 L225.882353,694.647059 C225.882353,634.562353 258.183529,578.430588 310.023529,548.275294 L310.023529,548.275294 L677.647059,334.138824 L677.647059,65 L1242.35294,65 Z M1242.35294,464.811765 L1242.35294,629.705882 L677.647059,629.705882 L677.647059,464.811765 L366.832941,645.856471 C349.552941,655.908235 338.823529,674.656471 338.823529,694.647059 L338.823529,694.647059 L338.823529,1081.47059 L564.705882,1081.47059 L564.705882,1520.02118 L931.651765,1733.70588 C949.044706,1743.98353 970.955294,1743.98353 988.348235,1733.70588 L988.348235,1733.70588 L1355.29412,1520.02118 L1355.29412,1081.47059 L1581.17647,1081.47059 L1581.17647,694.647059 C1581.17647,674.656471 1570.33412,655.908235 1553.05412,645.856471 L1553.05412,645.856471 L1242.35294,464.811765 Z M1807.05882,1194.41176 L1468.23529,1194.41176 L1468.23529,1533.23529 L1807.05882,1533.23529 L1807.05882,1194.41176 Z M451.764706,1194.41176 L112.941176,1194.41176 L112.941176,1533.23529 L451.764706,1533.23529 L451.764706,1194.41176 Z M1129.41176,177.941176 L790.588235,177.941176 L790.588235,516.764706 L1129.41176,516.764706 L1129.41176,177.941176 Z",
  fillRule: "evenodd",
  stroke: "none",
  strokeWidth: "1"
});

var IconModuleLine = /*#__PURE__*/function (_Component) {
  _inherits(IconModuleLine, _Component);

  var _super = _createSuper(IconModuleLine);

  function IconModuleLine() {
    _classCallCheck(this, IconModuleLine);

    return _super.apply(this, arguments);
  }

  _createClass(IconModuleLine, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(SVGIcon, Object.assign({}, this.props, {
        name: "IconModule",
        viewBox: "0 0 1920 1920"
      }), _ref);
    }
  }]);

  IconModuleLine.displayName = "IconModuleLine";
  return IconModuleLine;
}(Component);

IconModuleLine.glyphName = 'module';
IconModuleLine.variant = 'Line';
IconModuleLine.propTypes = _objectSpread({}, SVGIcon.propTypes);
export default IconModuleLine;
export { IconModuleLine };